import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateFactionName, factionKeys } from '@/services/factions'

export function useUpdateFactionName() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: ({ factionId, name }: { factionId: string; name: string }) =>
      updateFactionName(factionId, name),
    onSuccess: (_, { factionId }) => {
      // Invalidate all faction queries since the name affects multiple views
      queryClient.invalidateQueries({ queryKey: factionKeys.all })
      queryClient.invalidateQueries({ queryKey: factionKeys.detail(factionId) })
      queryClient.invalidateQueries({ queryKey: factionKeys.detailWithMembers(factionId) })
    },
  })

  return {
    updateFactionName: mutation.mutate,
    updateFactionNameAsync: mutation.mutateAsync,
    isUpdating: mutation.isPending,
    error: mutation.error,
  }
}
